import styled from '@emotion/styled';

export const GameContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  padding: 0;
`;
